function resolveApiBaseUrl() {
  const configured = import.meta.env.VITE_API_BASE_URL || '';
  if (configured) {
    return configured.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { hostname, origin } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
      return 'http://localhost:3001/api';
    }
    return `${origin.replace(/\/$/, '')}/api`;
  }

  return 'http://localhost:3001/api';
}

const API_BASE_URL = resolveApiBaseUrl();

function buildHeaders(token, extraHeaders = {}) {
  const headers = { ...extraHeaders };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export async function apiRequest(path, options = {}) {
  const token = Object.prototype.hasOwnProperty.call(options, 'token')
    ? options.token
    : localStorage.getItem('connektedin_token');
  const isForm = options.body instanceof FormData;
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: options.method || 'GET',
    headers: buildHeaders(
      token,
      isForm ? options.headers : { 'Content-Type': 'application/json', ...(options.headers || {}) }
    ),
    body: options.body ? (isForm ? options.body : JSON.stringify(options.body)) : undefined
  });

  if (!response.ok) {
    let payload = { error: 'Request failed' };
    try {
      payload = await response.json();
    } catch {
      payload = { error: response.statusText || 'Request failed' };
    }
    const error = new Error(payload.error || 'Request failed');
    error.payload = payload;
    throw error;
  }

  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return response.json();
  }
  return response;
}

export function getApiBaseUrl() {
  return API_BASE_URL;
}
